/**
 * Operator-approval queue client for semi_auto pairs.
 *
 *   GET  /api/pairs/:slug/suggestions?status=pending
 *   POST /api/pair-suggestions/:id/approve
 *   POST /api/pair-suggestions/:id/reject
 *
 * The pair-detail page polls listSuggestions every 10s and renders a
 * banner with reasoning + Approve / Reject buttons whenever a row is
 * pending. Approval re-dispatches the workflow so the queued action
 * runs through the same path full_auto would have used.
 */

import type {
  ListPairSuggestionsRes,
  PairSuggestion,
  PairSuggestionStatus,
} from "@pfh/shared";
import { api } from "../api";

export type { PairSuggestion, PairSuggestionStatus } from "@pfh/shared";

export async function listSuggestions(
  pairSlug: string,
  status: PairSuggestionStatus = "pending",
): Promise<PairSuggestion[]> {
  const res = await api.get<ListPairSuggestionsRes>(
    `/api/pairs/${encodeURIComponent(pairSlug)}/suggestions?status=${status}`,
  );
  return res.suggestions;
}

export async function approveSuggestion(id: number): Promise<void> {
  await api.post(`/api/pair-suggestions/${id}/approve`, {});
}

export async function rejectSuggestion(id: number): Promise<void> {
  await api.post(`/api/pair-suggestions/${id}/reject`, {});
}
